import {axiosFormDataInstance, axiosInstance} from "./axiosConfig";

// List user types with search and pagination
export const listUserTypes = async (page = 1, per_page = 10, search = '') => {
    const params = { page, per_page };
    if (search) params.search = search;
    return axiosInstance.get('/user-types', { params });
};

// Show specific user type
export const showUserType = async (id) => {
    return axiosInstance.get(`/user-types/${id}`);
};

// Create new user type
export const createUserType = async (formData) => {
    return axiosFormDataInstance.post('/user-types', formData);
};

// Update user type
export const updateUserType = async (id, formData) => {
    // Laravel doesn't handle PUT with FormData well, so we use POST with _method
    formData.append('_method', 'PUT');
    return axiosFormDataInstance.post(`/user-types/${id}`, formData);
};

// Delete user type
export const deleteUserType = async (id) => {
    return axiosInstance.delete(`/user-types/${id}`);
};
